module.exports = __webpack_public_path__ + "img/nova_logo.8efc02af.svg";